/*
  FormattedMessages.js - FormattedMessages for Root Component
*/

// NPM MODULES
import { FormattedMessage } from 'react-intl';
import React from 'react';

const FormattedMessages = {
  back: (
    <FormattedMessage
      id="Global.BackText"
      defaultMessage="Back"
    ></FormattedMessage>
  ),
  country: (
    <FormattedMessage
      id="Global.Country"
      defaultMessage="Country"
    ></FormattedMessage>
  ),
  go: <FormattedMessage id="Global.Go" defaultMessage="Go"></FormattedMessage>,
  loading: (
    <FormattedMessage id="AdminProvider.Loading" defaultMessage="Loading..." />
  ),
  no: <FormattedMessage id="Global.No" defaultMessage="No"></FormattedMessage>,
  uploadFiles: (
    <FormattedMessage
      id="Global.UploadFiles"
      defaultMessage="Upload Files"
    ></FormattedMessage>
  ),
  yes: (
    <FormattedMessage id="Global.Yes" defaultMessage="Yes"></FormattedMessage>
  ),
};

export default FormattedMessages;
